import { api } from '../lib/api'

export type PeopleImageUploadResponse = {
  url: string
  key: string
  thumb_url_512?: string
  thumb_key_512?: string
  width?: number
  height?: number
  bytes?: number
  mime?: string
}

export type MessengerAttachmentUploadResponse = {
  url: string
  key: string
  kind: 'image' | 'file' | string
  contentType?: string
  size?: number
}

export async function uploadPeopleImage(
  file: File,
  opts?: { onProgress?: (pct: number) => void }
): Promise<PeopleImageUploadResponse> {
  const fd = new FormData()
  // Backend accepts either "file" or "image". Use "file" consistently.
  fd.append('file', file)
  const { data } = await api.post<PeopleImageUploadResponse>(
    '/api/uploads/people-image',
    fd,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        const total = (evt.total ?? 0) as number
        const loaded = (evt.loaded ?? 0) as number
        if (!opts?.onProgress) return
        if (!total || total <= 0) return
        const pct = Math.max(0, Math.min(100, Math.round((loaded / total) * 100)))
        opts.onProgress(pct)
      },
    },
  )
  if (!data?.url || !data?.key) throw new Error('Upload did not return key/url')
  return data
}

export async function uploadMessengerAttachment(file: File): Promise<MessengerAttachmentUploadResponse> {
  const fd = new FormData()
  fd.append('file', file)
  const { data } = await api.post<MessengerAttachmentUploadResponse>(
    '/api/uploads/messenger-attachment',
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  if (!data?.url) throw new Error('Upload did not return a URL')
  return data
}
